import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background" data-testid="not-found-page">
      <div className="w-full max-w-md mx-4 border bg-card p-8">
        <div className="flex mb-4 gap-2">
          <AlertCircle className="h-8 w-8 text-destructive" />
          <h1 className="text-2xl font-serif">404 Page Not Found</h1>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">The page you're looking for doesn't exist.</p>
        <Link to="/" className="inline-block mt-6 text-sm uppercase tracking-widest text-accent hover:underline">Return Home</Link>
      </div>
    </div>
  );
}
